"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var visitorConnectionType_1 = require("../../utils/visitorConnectionType");
function network(criteria, services) {
    try {
        var connectionType_1 = (0, visitorConnectionType_1.getVisitorConnectionType)();
        var found = criteria.find(function (item) { return item.values[0] === connectionType_1; });
        return !!found;
    }
    catch (e) {
        return false;
    }
}
exports.default = network;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmV0d29yay5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJzcmMvbGliL3NlcnZpY2VzL3RhcmdldHMvbmV0d29yay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLDJFQUE0RTtBQUU1RSxTQUF3QixPQUFPLENBQUMsUUFBa0MsRUFBRSxRQUFzQjtJQUN0RixJQUFJO1FBQ0EsSUFBTSxnQkFBYyxHQUFHLElBQUEsZ0RBQXdCLEdBQUUsQ0FBQTtRQUNqRCxJQUFNLEtBQUssR0FBRyxRQUFRLENBQUMsSUFBSSxDQUFDLFVBQUMsSUFBSSxJQUFLLE9BQUEsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsS0FBSyxnQkFBYyxFQUFqQyxDQUFpQyxDQUFDLENBQUE7UUFDeEUsT0FBTyxDQUFDLENBQUMsS0FBSyxDQUFBO0tBQ2pCO0lBQUMsT0FBTyxDQUFDLEVBQUU7UUFDUixPQUFPLEtBQUssQ0FBQTtLQUNmO0FBQ0wsQ0FBQztBQVJELDBCQVFDIn0=